export default "__VITE_ASSET__DHnxXGDo__"